export interface FormFields {
  cropTypeId: string;
  regionId: string;
  startMonth: number | '';
  startDay: number | '';
  endMonth: number | '';
  endDay: number | '';
}

export interface FormErrors {
  cropTypeId?: string;
  regionId?: string;
  startDate?: string;
  endDate?: string;
  general?: string;
}

export const EMPTY_FIELDS: FormFields = {
  cropTypeId: '',
  regionId: '',
  startMonth: '',
  startDay: '',
  endMonth: '',
  endDay: '',
};

